import React, { useMemo } from 'react';
import { View, Text } from 'react-native';
import { colorType3 } from './LogStyles';

interface LogTypeBreakdownProps {
  data: any[];
  columns: any[];
  typeField?: string;
  valueField?: string;  // if provided, sum this numeric field per type instead of counting entries
  unit?: string;        // optional unit label shown after the value e.g. "m³"
}

export default function LogTypeBreakdown({
  data,
  columns,
  typeField = 'ObservationType',
  valueField,
  unit,
}: LogTypeBreakdownProps) {
  const choices = useMemo(() => {
    const col = columns.find((c: any) => c.columnName === typeField);
    return col?.choiceChoices
      ?.split('#;#')
      .filter((v: string) => v && v !== 'undefined') ?? [];
  }, [columns, typeField]);

  const counts = useMemo(() => {
    const map: Record<string, number> = {};
    data.forEach((item: any) => {
      const val = item[typeField];
      if (val) map[val] = (map[val] ?? 0) + (valueField ? (Number(item[valueField]) || 0) : 1);
    });
    return map;
  }, [data, typeField, valueField]);

  if (choices.length === 0) return null;

  return (
    <View style={{ flexDirection: 'row', flexWrap: 'wrap', gap: 8, paddingHorizontal: 10, paddingBottom: 10, justifyContent: 'center' }}>
      {choices.map((choice: string, idx: number) => {
        const count = counts[choice] ?? 0;
        const color = colorType3(String(idx));
        return (
          <View
            key={choice}
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              backgroundColor: '#F8F8F8',
              borderRadius: 20,
              paddingHorizontal: 10,
              paddingVertical: 5,
              gap: 6,
              borderWidth: 1,
              borderColor: '#EBEBEB',
            }}
          >
            <View style={{ width: 8, height: 8, borderRadius: 4, backgroundColor: color }} />
            <Text style={{ fontSize: 12, color: '#555' }}>{choice}</Text>
            <Text style={{ fontSize: 13, fontWeight: '700', color }}>{valueField ? Math.round(count) : count}{unit ? ` ${unit}` : ''}</Text>
          </View>
        );
      })}
    </View>
  );
}
